module.exports = __webpack_public_path__ + "static/logo-a9a14cd89bb5af62b1bfdb8b742d1882.svg";